import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b879556"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldCheckbox = _resolveComponent("FormFieldCheckbox")!
  const _component_ThroughNavigationTable = _resolveComponent("ThroughNavigationTable")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FormFieldCheckbox, {
      checked: _ctx.values.throughNavigation,
      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.throughNavigation) = $event)),
      name: "throughNavigation",
      label: "Сквозная навигация",
      disabled: !!_ctx.values.crossRoot
    }, null, 8, ["checked", "disabled"]),
    (_ctx.values.throughNavigation && !_ctx.values.crossRoot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ThroughNavigationTable, {
            cross: _ctx.values.cross,
            "category-option-list": _ctx.categoryOptionList
          }, null, 8, ["cross", "category-option-list"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.values.throughNavigation && _ctx.values.crossRoot)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(" Является элементом навигации относительно категории "),
          _createElementVNode("b", null, [
            _createTextVNode(" \""),
            _createVNode(_component_router_link, {
              class: "link",
              to: _ctx.getCategoryFormUrl({ categoryId: _ctx.values.crossRoot.id }),
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.values.crossRoot.name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createTextVNode("\" ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}